exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statistic-title[data-v-0cb23d76]{color:#fff;font-size:16px;line-height:25px}.statistic-count[data-v-0cb23d76]{font-size:24px;font-weight:700;margin-left:15px;color:#ffdc84;cursor:pointer}", ""]);

// exports
